import styled from "styled-components";

export const PopupMainTitle = styled.div`
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 20px;
`;

export const PopupMainText = styled.div`
  height: 280px;
  font-size: 16px;
  overflow-y: auto;
  white-space: pre-line;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const PopupButton = styled.button`
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: #f39626;
  border-radius: 16px;
  min-width: 200px;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 700;

  &:hover {
    background-color: #f9b535;
  }
`;

export const PopupNoButton = styled.button`
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: #fff;
  border-radius: 16px;
  min-width: 200px;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 700;
`;

export const PopupTitle2 = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 800;
`;

export const PopupMainText2 = styled.div`
  margin-bottom: 0px;
  font-size: 16px;
  overflow-y: auto;
  /* white-space: pre-line; */
  font-weight: 800;
  margin-bottom: 20px;
  margin-top: 20px;
`;
